'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import OfferingsSection from './OfferingsSection';
import TechnologyShowcase from './TechnologyShowcase';
import ROICalculator from './ROICalculator';
import ConsultationPortal from './ConsultationPortal';

const BillionDollarInteractive = () => {
  const [selectedOffering, setSelectedOffering] = useState<string | null>(null);

  return (
    <div className="min-h-screen">
      <HeroSection />
      <OfferingsSection 
        selectedOffering={selectedOffering}
        onOfferingSelect={setSelectedOffering}
      />
      <TechnologyShowcase />
      <ROICalculator />
      <ConsultationPortal />
    </div>
  );
};

export default BillionDollarInteractive;